<template>
  <v-container fluid class="pa-0 fill-height">
    <v-main class="grey lighten-4 fill-height pa-0">
      <v-container fluid class="pa-1">
        <v-row>
          <v-col>
            <v-container
              class="white rounded-lg alerts-list elevation-2 d-flex flex-column align-center justify-center"
            >
              <v-icon size="64" color="grey darken-1" class="mb-4">
                {{ icon }}
              </v-icon>
              <h2 class="text-h6 text-grey-darken-1 mb-2">{{ title }}</h2>
              <p class="text-body-1 text-grey-darken-1 text-center">
                {{ message }}
              </p>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-container>
</template>
  
<script>
export default {
  name: "AlertsErrorView",
  props: {
    icon: {
      type: String,
      default: "mdi-alert-circle-outline",
    },
    title: {
      type: String,
      default: "No Alerts Found",
    },
    message: {
      type: String,
      default: "There are currently no alerts to display.",
    },
  },
};
</script>
  
<style scoped>
.alerts-list {
  height: calc(100vh - 9.2em);
  overflow: hidden;
  margin: 16px;
  width: calc(100% - 2em);
  border-radius: 8px;
}
</style> 